// extracted by mini-css-extract-plugin
export var avatar = "K_P";
export var avatarLoading = "K_cl";
export var avatarLoadingActive = "K_cm";
export var avatarSending = "K_cj";
export var slideUp = "K_ck";